import { defineMessage } from 'services/localization';

export const messages = {
    mandatoryFieldsError: defineMessage('please_fill_all_mandatory_fields'),
    emailError: defineMessage('email_address_is_invalid'),
    phoneError: defineMessage('phone_number_is_invalid'),
    hyperLinkError: defineMessage('hyperlink_is_invalid'),
};
